// A small chevron: pointing right (rotated down when `open`), or left as a
// way back (`back`).
export default function Chevron({ open = false, back = false }) {
    return (
        <svg viewBox="0 0 12 12" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
            className={`h-[12px] w-[12px] shrink-0 transition-transform duration-150 motion-reduce:transition-none ${open ? "rotate-90" : ""}`}>
            <path d={back ? "M7.5 2.5 4 6l3.5 3.5" : "M4.5 2.5 8 6l-3.5 3.5"} />
        </svg>
    );
}
